module.exports = __webpack_public_path__ + "img/dialog-blank.c32bd9e2.png";